import ApiService from './api.service'

const resource = 'job-batch'

const JobBatchService = {

  /***
   * Get
   * @returns {*}
   */
  get (slug, payload = {}) {
    return ApiService.query(`${resource}/${slug}`, payload)
  },
  /***
   * Query
   * @returns {*}
   */
  query (payload) {
    return ApiService.post(`${resource}/query`, payload)
  },
}
export default JobBatchService
